import { RecursiveObject } from '@chakra-ui/react';

export const fonts: RecursiveObject<string> = {
  body: `var(--font-inter)`,
  sourceCodePro: `var(--font-source-code-pro)`,
};


